/* NB-011-DI */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.choose-your-benefit');
  if (!root) return;

  const cards = root.querySelectorAll('[data-choose-benefit-card]');
  if (!cards.length) return;

  cards.forEach((card) => {
    card.addEventListener('click', () => {
      cards.forEach((other) => {
        other.classList.remove('is-active');
        if (other.tagName === 'BUTTON') {
          other.setAttribute('aria-pressed', 'false');
        }
      });
      card.classList.add('is-active');
      if (card.tagName === 'BUTTON') {
        card.setAttribute('aria-pressed', 'true');
      }
    });
  });
});
